export const GET_OSS_POLICY_SUCCESS = 'GET_OSS_POLICY_SUCCESS';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
